module.exports = function(obj, field) {
	if (typeof obj == 'string') {
		var str = obj
	} else {
		var str = '';
		if (undefined == field || null == field) {
			field = 'titulo';
		}
		if (undefined != obj[field]) {
			str = obj[field];
		}
		
		if (undefined != obj.id && null != obj.id ) {
			str = str+'-'+obj.id;
		}
	}
	return str.toLowerCase().replace(/[^\w\d]/igm,' ').replace(/\s+/igm,' ').replace(/$\s+/igm,'').replace(/\s+$/igm,'').replace(/\s/igm,'-');
};


//////////////////
// WEBPACK FOOTER
// ./lib/nunjucks-filter-linkfy.js
// module id = 23
// module chunks = 0